import { platformApiClient } from './platform-api-client';
import type {
  PlatformAuditLogPage,
  PlatformDashboardSummary,
  PlatformHealth,
} from '@/types/platform-dashboard.types';

/**
 * Phase 12.2C — Platform Dashboard data access.
 *
 * The dashboard NEVER fetches `/platform/tenants` to derive a metric: aggregate
 * values come from the summary endpoint, computed server-side. That rule is the
 * core architectural constraint of this phase.
 */
export const platformDashboardService = {
  getSummary: (): Promise<PlatformDashboardSummary> =>
    platformApiClient
      .get<PlatformDashboardSummary>('/platform/dashboard/summary')
      .then((r) => r.data),

  getHealth: (): Promise<PlatformHealth> =>
    platformApiClient.get<PlatformHealth>('/platform/health').then((r) => r.data),

  getRecentActivity: (limit = 10): Promise<PlatformAuditLogPage> =>
    platformApiClient
      .get<PlatformAuditLogPage>(`/platform/audit-logs?limit=${limit}`)
      .then((r) => r.data),
};
